import React from 'react'
import { Typography, useDimensions } from '@telavita-core/react-design-kit'

import {
  ScheduleReminderSettings,
  AddressSettings,
  FamilyContactSettings,
  TranscriptionAuthorizerSettings,
} from '../components'
import { useUnleashFlag } from 'modules/FeatureFlags/Unleash/useUnleashFlag'
import { featureName } from 'modules/FeatureFlags/Unleash/constants'

import * as S from './styles'

export const PatientSettings: React.FC = () => {
  const { isMobile } = useDimensions()
  const { showFeature: showAudioTranscription } = useUnleashFlag(featureName.ENABLE_AUDIO_TRANSCRIPTION)

  return (
    <S.Container>
      <S.Header>
        <Typography
          id='settingsTitle'
          variant={isMobile ? 'header4' : 'header2'}
          center={isMobile}
        >
          Configurações
        </Typography>
      </S.Header>

      <S.SettingsContainer>
        {showAudioTranscription && <TranscriptionAuthorizerSettings />}
        <ScheduleReminderSettings />
        <AddressSettings />
        <FamilyContactSettings />
      </S.SettingsContainer>
    </S.Container>
  )
}